import { getCookie } from 'helpers/getCookie'

export interface IFacebookParams {
  fbc: string
  fbp: string
}

const FACEBOOK_PARAM_VERSION = 'fb.1'
const FACEBOOK_COOKIE_MAX_AGE_SECONDS = 90 * 24 * 60 * 60

export const createFacebookParams = (
  search = window.location.search,
  timestamp = Date.now(),
  random = Math.random(),
): IFacebookParams => {
  const fbclid = new URLSearchParams(search).get('fbclid') || ''
  const browserId = Math.floor(10 ** 9 + random * 9 * 10 ** 9)

  return {
    fbc: fbclid ? `${FACEBOOK_PARAM_VERSION}.${timestamp}.${fbclid}` : '',
    fbp: `${FACEBOOK_PARAM_VERSION}.${timestamp}.${browserId}`,
  }
}

const COOKIE_BASE_ATTRIBUTES = `path=/; max-age=${FACEBOOK_COOKIE_MAX_AGE_SECONDS}; SameSite=Lax; Secure`

// Mirrors the Facebook pixel: write the cookie on the broadest domain the
// browser accepts (the registrable domain) so it is shared across subdomains,
// falling back to host-only when no domain attribute sticks (e.g. localhost/IP).
const setSharedCookie = (name: string, value: string): void => {
  const encoded = `${name}=${encodeURIComponent(value)}`
  const hostParts = window.location.hostname.split('.')

  for (let i = hostParts.length - 2; i >= 0; i -= 1) {
    const domain = hostParts.slice(i).join('.')
    document.cookie = `${encoded}; domain=.${domain}; ${COOKIE_BASE_ATTRIBUTES}`

    if (getCookie(name)) {
      return
    }
  }

  document.cookie = `${encoded}; ${COOKIE_BASE_ATTRIBUTES}`
}

export const persistFacebookParams = ({
  fbc,
  fbp,
}: IFacebookParams): IFacebookParams => {
  const existingFbp = getCookie('_fbp')
  const existingFbc = getCookie('_fbc')
  const resolvedParams = {
    fbp: existingFbp || fbp,
    fbc: existingFbc || fbc,
  }

  if (!existingFbp) {
    setSharedCookie('_fbp', resolvedParams.fbp)
  }

  if (!existingFbc && fbc) {
    setSharedCookie('_fbc', resolvedParams.fbc)
  }

  return resolvedParams
}
